import { render, staticRenderFns } from "./load.vue?vue&type=template&id=352c19b7&scoped=true"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"
import style0 from "./load.vue?vue&type=style&index=0&id=352c19b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c19b7",
  null
  
)

export default component.exports